import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import founder from '../assets/founder.jpeg'
import { Link } from 'react-router-dom';
import videoreplace from '../assets/videoreplace.jpeg';
import snsesmak from '../assets/snses-mak.jpeg';
import storycard from '../assets/storycard.jpeg';
import allProducts from '../assets/allproducts.jpeg';
import snsessupportcom from '../assets/snsescomm.jpeg';
import bhc01 from '../assets/bhc01.jpeg';
import bhc02 from '../assets/bhc02.jpeg';
import bhc03 from '../assets/bhc03.jpeg';
import signature from '../assets/k_signature.png'


const OurStory = () => {
  const topRef = useRef(null);
  const founderRef = useRef(null);
  const quoteRef = useRef(null);
  const valuesRef = useRef(null);
  const communityRef = useRef(null);
  const craftRef = useRef(null);
  const images = [snsesmak, , storycard,allProducts]
  const bhcImages =[bhc01,bhc02,bhc03]

  const topInView = useInView(topRef, { once: true, amount: 0.3 });
  const founderInView = useInView(founderRef, { once: true, amount: 0.3 });
  const quoteInView = useInView(quoteRef, { once: true, amount: 0.5 });
  const valuesInView = useInView(valuesRef, { once: true, amount: 0.2 });
  const communityInView = useInView(communityRef, { once: true, amount: 0.3 });
  const craftInView = useInView(craftRef, { once: true, amount: 0.3 });

  return (
    <div className="bg-[#ffffff] min-h-screen overflow-x-hidden">
      {/* Top Section - Side by Side */}
      <section ref={topRef} className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={topInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-3xl font-thin tracking-wider text-gray-900 mb-16"
          >
            OUR STORY
          </motion.h1>

          <div className="grid md:grid-cols-2 gap-12 items-start">
            {/* Left Side - Video/Story */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={topInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div className="bg-[#1a1f3a] text-white mb-8 w-full">
                <img
                  src={videoreplace}
                  alt="SNSES Story"
                  className='w-full h-full object-cover'
                />
              </div>
            </motion.div>

            {/* Right Side - Essence */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={topInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              {/* <h2 className="text-3xl font-[5] font-metro-nova tracking-wider mb-6 text-gray-700">The essence of SNSES</h2> */}
              <div className="space-y-4 text-gray-700 text-[16px] leading-relaxed font-garamond">
                <p>
                  Founded in 2025, SNSES was born from a desire to celebrate culture through storytelling and sensory experiences. Each creation tells a story, one inspired by the history, art, and vibrant culture of Ghana. Every SNSES piece is designed to transport you to the vibrant heart of Ghana, offering a way to experience the richness of culture and the depth of history. Our products transform spaces, encouraging you to pause, notice, and engage with the subtle details that make each experience unique.
                </p>
                <p className="">
                  At SNSES, we focus on the subtle, the unexpected, and the details that often go unnoticed - the moments and textures that carry the fullest stories. Each creation turns ordinary spaces into experiences that invite a connection.
                </p>
                <p >
                  Through these layers, SNSES brings the essence of my home "Ghana" to the spaces you inhabit, creating a deeper connection to the stories that surround us and redefining the experience of luxury.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section ref={quoteRef} className="py-16 px-4 bg-white">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={quoteInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <p className="text-gray-600 leading-relaxed text-xl sm:text-[26px] font-garamond">
              "We create more than products. We craft experiences. Each piece is designed to resonate deeply, evoking emotion and inviting you to engage with, and immerse yourself in, the story woven through every detail."
            </p>

          </motion.div>
        </div>
      </section>

      {/* Meet the Founder Section */}
      <section ref={founderRef} className="py-20 px-4 bg-[#f4f1eb]">
        <div className="max-w-7xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={founderInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-center text-3xl font-thin tracking-wider text-gray-900 mb-12 uppercase"
          >
            Meet the founder
          </motion.h2>

          <div className="grid md:grid-cols-2 gap-12 items-center font-garamond">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={founderInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="space-y-6 text-gray-700"
            >
              <p className="leading-relaxed text-[16px] ">
              When I created SNSES, I didn't set out to build just another brand. From a young age, I've always had a creative mind and a deep love for storytelling. Being born and raised in Ghana, I grew up surrounded by the richness of culture, history, and artistry that shaped the way I see the world. I knew that whatever I created had to reflect that depth not just through products, but through stories brought to life.
              </p>
              <p className="leading-relaxed text-[16px]">
              I wanted SNSES to be more than something you buy. I wanted it to be something you experience. Each carefully crafted piece carries a connection to Ghana and to Africa's wider narrative. It's about celebrating heritage reimagined through craftsmanship.
              </p>
              <p className="leading-relaxed text-[16px]">
              From the beginning, my vision has been to work with local artisans whose expertise and creativity breathe authenticity into every creation. Together, we craft pieces that embody luxury, depth, and meaning. We craft creations that transform spaces.
              </p>
              <p className="leading-relaxed text-[16px]">
              SNSES exists to tell stories. My hope is that each SNSES piece fills your home creating moments you'll carry with you always.                           </p>
              <div className="flex flex-col pt-6">
                <p className="text-[16px] font-thin italic text-gray-800">With gratitude and love..</p>
                <img
                src={signature}
                alt='signature'
                className='h-20 w-40 object-contain'
                />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={founderInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="relative w-full"
            >
              <div className="bg-transparent w-full overflow-hidden shadow-xl">
                <img
                  src={founder}
                  alt="Founder"
                  className="w-full h-full object-contain"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section ref={valuesRef} className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={valuesInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-center mb-12"
          >
            <p className="text-gray-700 max-w-4xl mx-auto leading-relaxed text-[16px] font-garamond">
              We craft more than products — we create experiences. Each piece is designed to resonate deeply, emotion, and satisfaction,
              carrying with it the echoes of Ghanaian heritage and contemporary values. Every SNSES product tells beauty, our fine lingane
              kings offers the moment's supposed.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {images.map((img, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={valuesInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: 0.5 + index * 0.2 }}
                className="bg-gray-200 overflow-hidden shadow-lg h-64 flex items-center justify-center w-full"
              >
                <img
                  src={img}
                  alt={`Image ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* SNSES Supports Communities Section */}
      <section ref={communityRef} className="py-20 px-4 bg-[#f4f1eb]">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={communityInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
              className="bg-gray-200 overflow-hidden shadow-lg h-full flex items-center justify-center w-full"
            >
              <img
                src={snsessupportcom}
                alt="SNSES Community Support"
                className='w-full h-full object-cover'
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={communityInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="space-y-6"
            >
              <h2 className="text-3xl font-thin tracking-wider text-gray-900 mb-6 uppercase">
                SNSES supports communities
              </h2>
              <p className="text-gray-700 leading-relaxed text-[16px] font-garamond">
                At SNSES, luxury is not only defined by what we create but also by the impact we leave behind. We work closely with local artisans, highlighting their exceptional skill and creativity while honoring the culture that inspires our collections. By bringing their work to a global audience, every creation carries not only a story but also the hands and hearts of those who made it.
              </p>
              <p className="text-gray-700 leading-relaxed text-[16px] font-garamond">
                Our commitment extends beyond design. Through the MakeWay Foundation, a portion of every purchase supports education and provides young individuals with the tools and opportunities they need to flourish. By supporting the next generation of visionaries, we provide a foundation for them to build and lead.
              </p>
              <p className="text-gray-700 leading-relaxed text-[16px] font-garamond">
                For us, SNSES is more than a brand — it is a community. Every piece you bring into your space contributes to preserving culture, empowering the next generation, and inspiring the leaders and creators of tomorrow.
              </p>
              <div className="text-center pt-8">
                <Link to='/community'>
                  <button className="bg-[#4b0c0c] text-[#f1e7c7] hover:bg-[#4b0c0cd8] px-8 py-3 transition-colors text-[16px] tracking-wider">
                    Learn more
                  </button></Link>
              </div>
            </motion.div>

          </div>


        </div>
      </section>

      {/* Behind the Craft Section */}
      <section ref={craftRef} className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={craftInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-center text-3xl font-thin tracking-wider text-gray-900 mb-12 uppercase"
          >
            Behind the craft
          </motion.h2>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {bhcImages.map((img, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={craftInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: 0.3 + index * 0.2 }}
                className="bg-[#1a1f3a] overflow-hidden shadow-lg h-80 flex items-center justify-center group hover:scale-105 transition-transform duration-300 w-full"
              >
                  <img
                  src={img}
                  alt={`Behind the craft ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </motion.div>
            ))}
          </div>

          {/* Description Text */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={craftInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.9 }}
            className="max-w-6xl mx-auto space-y-6 text-center mb-8 font-garamond "
          >
            <p className="text-gray-700 leading-relaxed text-[16px]">
              Every SNSES creation begins with care. We work closely with skilled artisans, drawing on generations of knowledge and craftsmanship to ensure that each piece is made with precision and meaning. From the curation of the finest materials to the thoughtful design of our products, every step is guided by intention. We believe luxury is found not only in the finished product, but in the process itself.
            </p>
            <p className="text-gray-700 leading-relaxed text-[16px]">
              What you hold in your hands is the result of many hands - artisans, makers, and creators who pour their expertise into every stage. This is how we ensure that each product carries not just beauty, but also a story of dedication, responsibility, and care.
            </p>
          </motion.div>

          {/* Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={craftInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 1.2 }}
            className="text-center"
          >
            <Link to='/shop'>
              <button className="bg-[#4b0c0c] text-[#f1e7c7] hover:bg-[#4b0c0cd8] px-8 py-3 text-xs tracking-widest transition-colors">
                DISCOVER OUR PRODUCTS
              </button></Link>
          </motion.div>
        </div>
      </section>


    </div>
  );
};

export default OurStory;